module.exports = __webpack_public_path__ + "static/media/reportBadgeLevel5Locked.1d367c86.png";